import { render } from "./SupportDialog.vue?vue&type=template&id=23cb876a&scoped=true"
import script from "./SupportDialog.vue?vue&type=script&lang=js"
export * from "./SupportDialog.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-23cb876a"

export default script